import GridList from "../../../ui/components/List/GridList";
import GridListItem from "../../../ui/components/List/GridListItem";
import { baseUrl } from "../../../shared/config";
import { Button, Box, Typography, CircularProgress } from "@mui/material";
import { AccessTime } from "@mui/icons-material";
import moment from "moment";
import ProgressTracker from "../../../ui/components/ProgressTracker";
import CertificateButton from "../../../ui/pages/TrackPage/ui/components/CertificateButton";
import DatesLabel from "../../../ui/components/DatesLabel";
import { useLocation, useNavigate } from "react-router-dom";
import { setLastMenuPath } from "../../../shared/store/menu/menu";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { axios } from "../../../shared/lib/axios";
import RequestCourseEnrollment from "./RequestCourseEnrollment";
import _cookies from "../../../shared/utils/_cookies";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const mutationFn = async (data) => {
  const payload = {
    alunoid: data.studentId || _cookies.getItem("auth").user?.alunoid,
    email: _cookies.getItem("auth").user?.email,
    cursoid: data.cursoid,
    disciplinaid: data.disciplinaid,
  };

  const body = new FormData();

  body.append("dados", `${JSON.stringify([payload])}`);
  const res = await axios.middleware.post("/aluno.asmx/Nova_Matricula", body);
  return res;
};
const MandatoryAndRecommendedCourses = ({ queryFn, queryKey, filters }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryFn,
    queryKey,
    select: (_data) => {
      return _data
        .filter((course) => {
          if (filters.ids.length) {
            return filters.ids.includes(String(course.disciplinaid));
          }
          return true;
        })
        .filter((course) => {
          switch (filters.status) {
            case "Todos":
              return true;
            case "Expirados":
              return course.isExpired;
            case "Em andamento":
              return course.hasEnrollment && !course.isFinished;
            case "Concluídos":
              return course.isFinished;
            case "Sem matrícula":
              return !course.hasEnrollment;
            default:
              return false;
          }
        })
        .filter((course) => {
          if (!filters.search) {
            return true;
          } else {
            const regex = new RegExp("(" + filters.search + ")", "i");
            return regex.test(course.nome_disciplina);
          }
        });
    },
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCourse, setSelectedCourse] = useState();

  console.log(location);
  if (!data?.length)
    return (
      <div className="absolute top-0 right-0 bottom-0 left-0 flex align-middle justify-center items-center">
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Typography variant="captions" color="GrayText">
            Sem resultados
          </Typography>
        )}
      </div>
    );
  return (
    <RequestCourseEnrollment
      courseData={selectedCourse}
      mutationFn={mutationFn}
      onSuccess={() => {
        queryClient.invalidateQueries({ queryKey });
      }}
    >
      {(dialog) => {
        return (
          <GridList>
            {data?.map((course) => {
              const {
                accessLabel,
                canBeAccessedNow,
                isFinished,
                isExpired,
                sendCertificate,
                elapsedTimePercentage,
                remainingDays,
              } = course;
              return (
                <GridListItem
                  label={course.nome_disciplina}
                  subLabel={course.nome_curso}
                  imageUrl={`${baseUrl}/Membros/fotos/${course.foto}`}
                  footer={
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Box
                        sx={{
                          // padding: "16px",

                          display: "flex",
                          flexWrap: "wrap",
                          "& > *": {
                            paddingY: 1,
                            flex: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          },
                        }}
                      >
                        <Box sx={{ flexDirection: "row" }}>
                          <AccessTime
                            color="primary"
                            sx={{ fontSize: "2rem" }}
                          />

                          <Typography sx={{ marginLeft: 1 }} fontSize="0.75rem">
                            Duração <br />
                            <b>{course.duracao_dias} dias</b>
                          </Typography>
                        </Box>
                        {!!course.porcentagem && !isExpired && (
                          <Box hidden={true} sx={{ flexDirection: "column" }}>
                            <Typography variant="caption">Andamento</Typography>
                            <ProgressTracker
                              sx={{ width: "70px", marginRight: "5px" }}
                              color="secondary"
                              progress={course.porcentagem}
                            />
                            <Typography variant="caption">
                              {course.porcentagem}%
                            </Typography>
                          </Box>
                        )}

                        <Box
                          sx={{
                            flexDirection: "row",
                            display:
                              elapsedTimePercentage >= 0 ? "flex" : "none",
                          }}
                        >
                          <ProgressTracker
                            sx={{ width: "30px", height: "30px" }}
                            variant="clock"
                            color="secondary"
                            progress={100 - elapsedTimePercentage}
                          />
                          <Typography sx={{ marginLeft: 1 }} fontSize="0.75rem">
                            {" "}
                            <b>{remainingDays} dias</b> <br /> restantes
                          </Typography>
                        </Box>

                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                            }}
                          >
                            {Boolean(course.dtliberacao) &&
                              Boolean(course.dtlimite) && (
                                <DatesLabel
                                  datesArray={[
                                    {
                                      date: moment(course.dtliberacao).format(
                                        "DD/MM/YYYY"
                                      ),
                                    },
                                    {
                                      date: moment(course.dtlimite).format(
                                        "DD/MM/YYYY"
                                      ),
                                    },
                                  ]}
                                />
                              )}
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          marginTop: "auto",
                          padding: 2,
                          gap: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          alignItems: "center",
                          button: {
                            width: "100%",
                          },
                          "& > button:nth-child(2)": {
                            color: "#22C55E",
                            borderColor: "#22C55E",
                          },
                        }}
                      >
                        {!course.hasEnrollment && course.selfSubscribe ? (
                          <Button
                            variant="contained"
                            onClick={() => {
                              setSelectedCourse(course);
                              dialog.open();
                            }}
                            disabled={course.QTD_PEDIDOS > 0}
                          >
                            {course.QTD_PEDIDOS > 0
                              ? "Aguardando liberação"
                              : "Inscreva-se"}
                          </Button>
                        ) : (
                          course.canBeAccessedNow && (
                            <Button
                              onClick={() => {
                                dispatch(
                                  setLastMenuPath(
                                    location.pathname + location.search
                                  )
                                );
                                navigate(
                                  `/curso/${course.cursoid}/${course.disciplinaid}`
                                );
                              }}
                              variant="outlined"
                              disabled={!canBeAccessedNow}
                              color={canBeAccessedNow ? "success" : "info"}
                            >
                              {accessLabel}
                            </Button>
                          )
                        )}

                        {isFinished && sendCertificate && (
                          <CertificateButton
                            customButton={<Button />}
                            course={{
                              matricula_conclusa: course.matriculaid,
                              DISCIPLINAID: course.disciplinaid,
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  }
                />
              );
            })}
          </GridList>
        );
      }}
    </RequestCourseEnrollment>
  );
};

export default MandatoryAndRecommendedCourses;
